import { useReportStore } from '@/store/report'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useSharePopover } from './useSharePopover'

export function useReportShare() {
  const reportStore = useReportStore()
  const {
    hasEnergyData,
    hasCompareEnergySensorReadings,
    hasTemperature,
    hasCompareTemperature,
    getBaseEnergySensorReadings,
    getCompareEnergySensorReadings,
    getBaseTemperatureReadings,
    getCompareTemperatureReadings,
  } = storeToRefs(reportStore)

  const availableOptions = computed(() => {
    const options = []

    if (hasEnergyData.value) {
      options.push({ id: 'demandBase', label: 'Demanda Base', selected: false })
    }

    if (hasCompareEnergySensorReadings.value) {
      options.push({ id: 'demandCompare', label: 'Demanda Comparação', selected: false })
    }

    if (hasTemperature.value) {
      options.push({ id: 'temperatureBase', label: 'Temperatura Base', selected: false })
    }

    if (hasCompareTemperature.value) {
      options.push({ id: 'temperatureCompare', label: 'Temperatura Comparação', selected: false })
    }

    return options
  })

  const generateChartCSV = (chart: any) => {
    let csvContent = ''

    if (chart.type === 'demand') {
      csvContent = 'Sensor,Data/Hora UTC-0,Potência Total (kW)\n'

      chart.data.forEach((sensor: any) => {
        sensor.readings.forEach((reading: any) => {
          csvContent += `${sensor.sensorName},${reading.time},${reading.total_power}\n`
        })
      })
    } else if (chart.type === 'temperature') {
      csvContent = 'Sensor,Data/Hora UTC-0,Temperatura (°C)\n'

      chart.data.forEach((sensor: any) => {
        sensor.readings.forEach((reading: any) => {
          const temperatureValue = reading.value || reading.temperature || reading.total_power
          csvContent += `${sensor.sensorName},${reading.time},${temperatureValue.toFixed(2)}\n`
        })
      })
    }

    // Criar e baixar o arquivo CSV
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', `${chart.name}_${new Date().toISOString().split('T')[0]}.csv`)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  // Usar o composable base
  const sharePopover = useSharePopover({
    captureSelector: '#report-view-container',
    captureFileName: 'report.png',
    onGenerateCSV: () => {
      const charts = []

      if (sharePopover.selectedOptions.value.demandBase && hasEnergyData.value) {
        charts.push({
          name: 'demanda_base',
          data: getBaseEnergySensorReadings.value,
          type: 'demand',
        })
      }

      if (sharePopover.selectedOptions.value.demandCompare && hasCompareEnergySensorReadings.value) {
        charts.push({
          name: 'demanda_comparacao',
          data: getCompareEnergySensorReadings.value,
          type: 'demand',
        })
      }

      if (sharePopover.selectedOptions.value.temperatureBase && hasTemperature.value) {
        charts.push({
          name: 'temperatura_base',
          data: getBaseTemperatureReadings.value,
          type: 'temperature',
        })
      }

      if (sharePopover.selectedOptions.value.temperatureCompare && hasCompareTemperature.value) {
        charts.push({
          name: 'temperatura_comparacao',
          data: getCompareTemperatureReadings.value,
          type: 'temperature',
        })
      }

      // Gerar CSV para cada gráfico selecionado
      charts.forEach((chart) => {
        generateChartCSV(chart)
      })
    },
  })

  return {
    ...sharePopover,
    availableOptions,
  }
}
